import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const BottonLine = styled(Box)`
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--chakra-space-6);
    margin-top: auto;
    padding-top: var(--chakra-space-8);
    border-top: 1px solid var(--chakra-colors-grayscale-100);
`

export const FormContainer = styled(Box)`
    min-height: 480px;
    display: flex;
    flex-direction: column;
`
